var site = site || {};
site.extras = site.extras || {};
site.extras.initDone = false;
/*
 Extras
 */
site.extras.upload = {
	init: function (urls, lang) {
		if (site.extras.initDone === false) {
			site.extras.initDone = true;
			$('ul#images').sortable({
				'opacity': 0.8,
				'update': function (e, ui) {
					var $el = $(this);
					$el.sortable('disable').addClass('disabled');
					$.post(urls.sort, $(this).sortable('serialize'), function (d) {
						if (d.success !== true) {
							moya.message.add(lang.galleryErrorOnSave);
							$el.sortable('cancel');
						}
						$el.removeClass('disabled');
						$el.sortable('enable');
					});
				}
			});
			$('#ffile').uploadify({
				'uploader': '/_moya/js/jquery/uploadify/uploadify.swf',
				'script': urls.script,
				'cancelImg': '/_moya/js/jquery/uploadify/cancel.png',
				'auto': true,
				'multi': true,
				'folder': '/tmp',
				'fileDesc': lang.galleryImageUploadFileDescription,
				'fileExt': '*.jpg;*.jpeg;*.gif;*.png;*.JPG;*.JPEG;*.GIF;*.PNG,*.pdf;*.PDF;*.doc;*.docx;*',
				'buttonText': lang.galleryFileBrowse,
				'queueID': 'ffileQueue',
				'onError': function () {
					$('#notice').html('<div class="message"><div class="error">' + lang.galleryErrorOnSave + '</div></div>');
				},
				'onComplete': function (e, q, f, r) {
					var n = $('#notice');
					switch (r) {
						case 'noAlbum':
							n.html('<div class="message"><div class="error">' + lang.galleryErrorNoAlbumName + '</div></div>');
							break;
						case 'noSave':
							n.html('<div class="message"><div class="error">' + lang.galleryErrorOnSave + '</div></div>');
							break;
					}
				},
				'onAllComplete': function () {
					window.location.reload();
				}
			});
		}
	}
};

site.extras = $.extend(site.extras, {
	formHasChanged: false,
	itemForm: function () {
		$('select#urlSitemap').bind('change click keyup', function () {
			$('input#url').val($(this).val());
		});
	},
	categoriesSelect: function () {
		$('select#categoryId').bind('change', function () {
			if ($(this).val() != 'selectionKey') {
				window.location = '?categoryId=' + $(this).val();
			}
		});

		$(window).on('beforeunload', function () {
			return 'Any unsaved changes will be lost';
		});

		$(document).on("submit", "form", function (event) {
			$(window).off('beforeunload');
		});
	},
	sort: function (url) {
		var $sortList = $('#sortList');

		$sortList.sortable();
		$sortList.on('sortupdate', function () {
			var order = $(this).sortable('toArray').toString();
			$.ajax({
				type: "POST",
				url: url,
				data: {order: order, _skipResize: 1}
			});
		});

		$('a', '.sortOptions').on('click', function (e) {
			e.preventDefault();
			var $sortList = $('#sortList'),
				listItems = $('li', $sortList),
				method = $(this).data('method'),
				direction = $(this).data('direction');

			listItems.sort(function (a, b) {
				a = $(a).data(method);
				b = $(b).data(method);

				if (direction === 'asc') {
					return typeof a === "string" && typeof b === "string" ? collateStrings(a, b) : a < b ? -1 : a > b ? 1 : 0;
				}
				else {
					return typeof a === "string" && typeof b === "string" ? collateStrings(b, a) : b < a ? -1 : b > a ? 1 : 0;
				}
			});
			$sortList.append(listItems);
			$sortList.trigger('sortupdate');
		});
	},
});

/* sortBy functions & helpers extracted and slightly modified from
 * Sugar Library v1.3.7
 * Freely distributable and licensed under the MIT-style license.
 * Copyright (c) 2012 Andrew Plummer
 * http://sugarjs.com/arrays#sorting
 * https://github.com/Mottie/tablesorter/issues/212
 */
var array = {
		AlphanumericSortIgnoreCase: true,
		AlphanumericSortEquivalents: {}
	},

	// Alphanumeric collation helpers
	collateStrings = function (a, b) {
		var aValue, bValue, aChar, bChar, aEquiv, bEquiv, index = 0,
			tiebreaker = 0;
		a = getCollationReadyString(a);
		b = getCollationReadyString(b);
		do {
			aChar = getCollationCharacter(a, index);
			bChar = getCollationCharacter(b, index);
			aValue = getCollationValue(aChar);
			bValue = getCollationValue(bChar);
			if (aValue === -1 || bValue === -1) {
				aValue = a.charCodeAt(index) || null;
				bValue = b.charCodeAt(index) || null;
			}
			aEquiv = aChar !== a.charAt(index);
			bEquiv = bChar !== b.charAt(index);
			if (aEquiv !== bEquiv && tiebreaker === 0) {
				tiebreaker = aEquiv - bEquiv;
			}
			index += 1;
		} while (aValue != null && bValue != null && aValue === bValue);
		if (aValue === bValue) return tiebreaker;
		return aValue < bValue ? -1 : 1;
	},

	getCollationReadyString = function (str) {
		if (array.AlphanumericSortIgnoreCase) {
			str = str.toLowerCase();
		}
		return str.replace(array.AlphanumericSortIgnore, '');
	},

	getCollationCharacter = function (str, index) {
		var chr = str.charAt(index),
			eq = array.AlphanumericSortEquivalents || {};
		return eq[chr] || chr;
	},

	getCollationValue = function (chr) {
		var order = array.AlphanumericSortOrder;
		return chr ? order.indexOf(chr) : null;
	},

	order = 'AÁÀÂÃĄBCĆČÇDĎÐEÉÈĚÊËĘFGĞHıIÍÌİÎÏJKLŁMNŃŇÑOÓÒÔPQRŘSŚŠŞTŤUÚÙŮÛÜVWXYÝZŹŻŽÞÆŒØÕÅÄÖ',
	equiv = '',
	equivalents = {};

array.AlphanumericSortOrder = $.map(order.split(''), function (str) {
	return str + str.toLowerCase();
}).join('');

$.each(equiv.split(','), function (i, set) {
	var equivalent = set.charAt(0);
	$.each(set.slice(1).split(''), function (i, chr) {
		equivalents[chr] = equivalent;
		equivalents[chr.toLowerCase()] = equivalent.toLowerCase();
	});
});
